module.exports = __webpack_public_path__ + "f83e6246a36d791093371c3376267028.pdf";